import { QueryClient } from '@tanstack/react-query';

/**
 * Shared QueryClient instance.
 * Extracted from main.tsx so it can be imported by apiClient.ts
 * for cache invalidation on 401 responses.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: (failureCount, error: any) => {
                // Don't retry on network errors
                if (error?.name === 'NetworkError' || !navigator.onLine) {
                    return false;
                }
                // Don't retry on auth errors
                if (error?.response?.status === 401) {
                    return false;
                }
                return failureCount < 3;
            },
            retryDelay: (attemptIndex) =>
                Math.min(1000 * 2 ** attemptIndex, 30000),
        },
    },
});
